export default __webpack_public_path__ + "static/media/heating.49fcad0b.svg";